/**
 * SocketConnector class.
 *  Base class for all socket based connectors
 *
 * @constructor
 * @param {Object} socket - scoketio socket.
 */

export default class SocketConnector {

    constructor(socket) {
        this.socket = socket;
        this.verbose = false;
        this.verbose_name = "SocketConnector:";
        this.emit_name = "frontendRpc";
        this.controller_id = null;
        this.__call = this.__callSocketRpc;
        this.proceed_errors = true;

        this.SORT_DESC = 3;  // TODO static
        this.SORT_ASC = 4;
    }


    __log() {
        if(this.verbose)
            console.log.bind(console).apply(null,arguments);
        // bind нужен для старого хрома http://qaru.site/questions/622200/why-i-cant-pass-consolelog-as-a-callback-argument-in-chrome-and-safari
    };

    async __call(method, params) {
        return this.__callSocketRpc(method, params);
    }

    __callSocketRpc(method, params) {
        return new Promise( (resolve, reject) => {
            this.__log(this.verbose_name, "emit", method, params);

            this.socket.emit( this.emit_name , {
                controller_id: this.controller_id,
                method: method,
                params: params
            }, (e,r) => {
                this.__onResult( e, r , method);
                if(e)
                    return reject(e);
                return resolve(r);
            });

        } )
    };

    __onResult(err,result,method) {
        if (method === undefined)
            method = "";

        if(err)
            return this.__onError(err, method);

        this.__log(this.verbose_name,"result ("+method+")", result);
        return true;
    };

    __onError(err, method) {
        if (method === undefined)
            method = "";

        this.__log(this.verbose_name,"error ("+method+")", err);
        return this.proceed_errors;
    };

}



  
  
// socket.emitAsync = function(event, data) {
//     return new Promise((resolve, reject) => {
//         if (!this) {
//             reject('No socket connection.');
//         } else {
//             loggerLocal.debug("emit event ",event);
//             this.emit(event, data, (err, resp) => {
//                 if (err) {                    
//                     loggerLocal.error("emmit error ", event, err);
//                     reject(err);
//                 } else {
//                     loggerLocal.debug("event resolve ", event, resp);
//                     resolve(resp);
//                 }
//             });
//         }
//     });
// }